import { useTranslation } from 'react-i18next';
import { QueryErrorState } from '@/components/admin/shared/QueryErrorState';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import {
  useConsultationIntakeFieldsQuery,
  useConsultationOutcomeOptionsQuery,
} from '@/hooks/useConsultationConfig';
import { useWorkspacePreVisitQuestionsQuery } from '@/hooks/usePreVisitQuestions';
import { IntakeFieldsEditor } from './IntakeFieldsEditor';
import { OutcomeOptionsEditor } from './OutcomeOptionsEditor';
import { PreVisitFormEditor } from './PreVisitFormEditor';

export function ConsultationSettingsSection() {
  const { t } = useTranslation('consultations');
  const intakeFieldsQuery = useConsultationIntakeFieldsQuery();
  const outcomeOptionsQuery = useConsultationOutcomeOptionsQuery();
  const preVisitQuestionsQuery = useWorkspacePreVisitQuestionsQuery();

  if (
    intakeFieldsQuery.isLoading === true ||
    outcomeOptionsQuery.isLoading === true ||
    preVisitQuestionsQuery.isLoading === true
  ) {
    return (
      <div className="py-16 flex justify-center">
        <LoadingSpinner className="w-7 h-7" />
      </div>
    );
  }

  if (
    intakeFieldsQuery.isError === true ||
    outcomeOptionsQuery.isError === true ||
    preVisitQuestionsQuery.isError === true ||
    intakeFieldsQuery.data === undefined ||
    outcomeOptionsQuery.data === undefined ||
    preVisitQuestionsQuery.data === undefined
  ) {
    return (
      <QueryErrorState
        onRetry={function retry() {
          intakeFieldsQuery.refetch();
          outcomeOptionsQuery.refetch();
          preVisitQuestionsQuery.refetch();
        }}
      />
    );
  }

  return (
    <div className="space-y-5">
      <p className="text-xs text-zoomuted flex items-center gap-2">
        {t('settings.note')}
      </p>
      <PreVisitFormEditor initialQuestions={preVisitQuestionsQuery.data} />
      <IntakeFieldsEditor initialFields={intakeFieldsQuery.data} />
      <OutcomeOptionsEditor initialOptions={outcomeOptionsQuery.data} />
    </div>
  );
}
